import React from 'react';

const OtherSection = () => {
	return (
		<section className='other'>
			<div className='box'>
				<div className='item'>
					<p className='white poppins'>Overline</p>
					<h2 className='white'>Przekonujący nagłówek w CTA</h2>
					<p className='white text'>
						But I must explain to you how all this mistaken idea of
						denouncing pleasure and praising pain was born.
                    </p>
                    <button className='primaryLarge'>Napisz do nas</button>
				</div>
			</div>
		</section>
	);
};

export default OtherSection;
